import BookingButtonView from '@redturtle/volto-io-prenoto/components/Blocks/BookingButton/View';
import BookingButtonEdit from '@redturtle/volto-io-prenoto/components/Blocks/BookingButton/Edit';
import bookingSVG from '@plone/volto/icons/blog-entry.svg';

export const IoPrenotoBlocks = (config) => {
  const customBlocksOrder = [{ id: 'ioprenoto', title: 'IO Prenoto' }];

  config.blocks.groupBlocksOrder = config.blocks.groupBlocksOrder.concat(
    customBlocksOrder,
  );

  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,

    bookingButton: {
      id: 'bookingButton',
      title: 'Bottone prenotazioni',
      icon: bookingSVG,
      group: 'ioprenoto',
      view: BookingButtonView,
      edit: BookingButtonEdit,
      restricted: (properties) => properties['@type'] !== 'Servizio',
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
  };
};
